import React from 'react';
import Link from 'gatsby-link';

import Header1 from '../../typographies/header1';
import Labels from '../articleLabel';
import Para2 from '../../typographies/para2';

const ArticleListItem = ({title, link, date, target, tags}) => {
  let component;
  if (target === '') {
    component = (
      <Link className="Article-list-item" to={link} target={target}>
        <Header1 className="strong" text={title} />
        <Para2 className="grey" text={date} />
        <Labels labels={tags} />
      </Link>
    );
  } else {
    component = (
      <a className="Article-list-item" href={link} target={target}>
        <Header1 className="strong" text={title} />
        <Para2 className="grey" text={date} />
        <Labels labels={tags} />
      </a>
    );
  }
  return component;
};

export default ArticleListItem;



// WEBPACK FOOTER //
// ./src/components/article/articleListItem/index.js